import { GET_ORDER_STATUSES } from '../actions/types';

const initialState = {
  list: []
};

export default function(state = initialState, action = {}) {
  switch (action.type) {
    case GET_ORDER_STATUSES: {
      return { ...state, ...{ list: action.orderStatusesData } };
    }
    default:
      return state;
  }
}
